import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
const removeCookieClientAuth = () => {
    const cookies = new Cookies();
    cookies.remove(cookiesKeys.clientAuth);
};
export default removeCookieClientAuth;
